import { useState } from 'react';

import { useAuth } from '../contexto/auth.tsx';
import { Aviso, Botao, Campo } from '../componentes/ui.tsx';

export function Login() {
  const { entrar } = useAuth();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(evento: React.FormEvent) {
    evento.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não foi possível entrar.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center px-6">
      <form onSubmit={enviar} className="w-full max-w-sm space-y-5">
        <div>
          <h1 className="text-xl font-semibold text-slate-900">Premiação · Call Center</h1>
          <p className="mt-1 text-sm text-slate-500">Entre para calcular ou consultar fechamentos.</p>
        </div>

        {erro !== null && (
          <Aviso tom="erro">
            <p>{erro}</p>
          </Aviso>
        )}

        <Campo rotulo="E-mail" tipo="email" valor={email} onChange={setEmail} obrigatorio />
        <Campo rotulo="Senha" tipo="password" valor={senha} onChange={setSenha} obrigatorio />

        <Botao submit carregando={enviando}>
          Entrar
        </Botao>
      </form>
    </div>
  );
}
